<div class="catalog-content config-wrap form-group">

  <form name="form" (ngSubmit)="f.form.valid && proceesData()" #f="ngForm" novalidate>

    <mat-radio-group name="configType" [(ngModel)]="selectedConfigType" (change)="radioChange($event)">
      <mat-radio-button *ngFor="let cType of availableConfigTypes" [value]="cType.value" [disabled]="cType?.disabled"
        class="padding-right-30" [checked]="cType.value === selectedConfigType">
        {{ cType.name }}
      </mat-radio-button>
    </mat-radio-group>

    <div class="col-md-6 padding-left-0 padding-top-30" *ngIf="selectedConfigType === 'LOCATION'">
      <mat-form-field>
        <input matInput placeholder="Enter Location" [(ngModel)]="enteredLocation" name="enteredLocation" required />
      </mat-form-field>
    </div>
    <div class="col-md-6 padding-left-0 padding-top-30" *ngIf="selectedConfigType === 'DEPARTMENT'">
      <mat-form-field>
        <input matInput placeholder="Enter Department" [(ngModel)]="enteredDepartment" name="enteredDepartment"
          required />
      </mat-form-field>
    </div>
    <div class="margin-top-20 text-center">
      <button 
        mat-raised-button 
        color="primary" 
        class="mat-button-large" 
        type="submit" [disabled]="!f.valid">
        <span *ngIf="!dataSelected">Submit</span>
        <span *ngIf="dataSelected">Update</span>
      </button>
    </div>
  </form>

  <div class="list-wrap">
    <div class="col-lg-12 row">
      <div class="col-lg-12 ml-2 data-sect">
        <div class="col-lg-12">
          <h3>{{selectedConfigType | titlecase}} List</h3>
        </div>

        <table class="table" [svData]="data" #sv="svDataTable" [svRowsOnPage]="pageSize"
          *ngIf="data && data.length > 0">

          <thead>
            <tr>
              <th>{{selectedConfigType | titlecase}}</th>
              <th class="text-center">Edit</th>
              <th class="text-center">Delete</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let item of sv.data">
              <td>{{ item.value }}</td>
              <td class="text-center">
                <img src="assets/images/Edit.png" class="cursor-pointer" (click)="editConfig(item)">
              </td>

              <td class="text-center">
                <img src="assets/icons/delete_icon.png" class="cursor-pointer" (click)="deleteData(item)">
              </td>
            </tr>
          </tbody>

          <tfoot *ngIf="data?.length > pageSize">
            <tr>
              <td colspan="5" class="center-paginator">
                <sv-bootstrap-paginator></sv-bootstrap-paginator>
              </td>
            </tr>
          </tfoot>
        </table>
        <div *ngIf="data?.length <= 0">No Data found</div>
      </div>
    </div>
  </div>
</div>